import {
  Alert,
  Button,
  Form,
  Modal,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { RiRefreshLine, RiSave2Fill } from "react-icons/ri";
import ReactDataGrid from "@inovua/reactdatagrid-community";
import { useCallback, useEffect, useState } from "react";
import { LoadCountData } from "./LoadCountData";
import { ImFilePdf } from "react-icons/im";
import { exportPDF_count } from "../excelExport";

const Count = () => {
  //----- GET CURRENT USER -----//
  const tokenString = sessionStorage.getItem("token");
  const userToken = JSON.parse(tokenString);
  const UserID = userToken.userId;

  const [dataSource, setDataSource] = useState([]);
  const [searchString, setSearchString] = useState("");
  const [disabled, setDisabled] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showConfirmDeleteModal, setShowConfirmDeleteModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [numRows, setNumRows] = useState(0);
  const [numRowsSelected, setNumRowsSelected] = useState(0);

  //Store reference to grids for exporting PDF
  const [gridRef_count, setGridRef_count] = useState(null);

  //Sets data for the rows that are checked
  const [selected, setSelected] = useState();

  // Sets datasource on load and when searchString changes
  useEffect(() => {
    async function fetchData() {
      try {
        const data = await LoadCountData(searchString, UserID);
        setDataSource(data.data);
        console.log(dataSource);
        setNumRows(data.count);
        //data.data.length > 0 ? setDisabled(false) : setDisabled(true);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
    fetchData();
  }, [searchString, UserID]);

  const columns = [
    { name: "Product", header: "Product", type: "string", defaultFlex: 0 },
    {
      name: "Description",
      header: "Description",
      type: "string",
      defaultFlex: 1,
    },
    {
      name: "Location",
      header: "Location",
      type: "string",
      defaultFlex: 0,
    },
    {
      name: "Site",
      header: "Site",
      type: "string",
      defaultFlex: 0,
    },
    {
      name: "Username",
      header: "Username",
      type: "string",
      defaultFlex: 0,
    },
    {
      name: "Counted",
      header: "Counted",
      type: "number",
      defaultFlex: 0,
      textAlign: "end",
    },
    {
      name: "SystemQty",
      header: "System Quantity",
      type: "number",
      defaultFlex: 0,
      textAlign: "end",
    },
    {
      name: "Variance",
      header: "Variance",
      type: "number",
      defaultFlex: 0,
      textAlign: "end",
    },
  ];

  // Styles and setup for grid
  const gridStyle = {
    minHeight: "83vh",
    margin: 10,
  };

  const theme = "default-dark";

  // Handle row click
  const onSelectionChange = useCallback(({ selected }) => {
    if (selected !== true) {
      setSelected(selected);

      console.log(selected);
      if (Object.keys(selected).length > 0) {
        setDisabled(false);
      } else {
        setDisabled(true);
      }
      // get number of rows selected
      setNumRowsSelected(Object.keys(selected).length);
      console.log(Object.keys(selected).length);
    }
    //console.log(JSON.stringify(toArray(selected)));
    // console.log(selected)
  }, []);

  const applyStockCount = async (dataSource, userId) => {
    const url = `/applyStockCount/${userId}`;

    try {
      const response = await fetch(url);
      if (response.status !== 200) {
        throw new Error(`Request failed with status ${response.status}`);
      }

      const result = await response.json();
      // Show modal
      setShowModal(true);
      // Reload table
      try {
        const data = await LoadCountData(searchString, UserID);
        setDataSource(data.data);
        console.log("data", data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    } catch (error) {
      return console.error("Error:", error);
    }
  };

  const handleCopyToClipboard = (data) => {
    //alert('Copied Data : '+JSON.stringify(data));
    navigator.clipboard.writeText(data);
  };

  // Context menu for stock grid, to allow copying of data such as product number
  const renderRowContextMenu = useCallback((menuProps, { rowProps }) => {
    menuProps.autoDismiss = true;
    menuProps.items = [
      {
        label: "Copy Product Number ",
        onClick: () => handleCopyToClipboard(rowProps.data.Product),
      },
      {
        label: "Copy Description ",
        onClick: () => handleCopyToClipboard(rowProps.data.Description),
      },
      {
        label: "Copy Username ",
        onClick: () => handleCopyToClipboard(rowProps.data.Username),
      },
      {
        label: "Copy Counted ",
        onClick: () => handleCopyToClipboard(rowProps.data.Counted),
      },
      {
        label: "Copy System QTY ",
        onClick: () => handleCopyToClipboard(rowProps.data.SystemQty),
      },
      {
        label: "Copy Variance ",
        onClick: () => handleCopyToClipboard(rowProps.data.Variance),
      },
    ];
  }, []);

  const deleteStockCount = async (data) => {
    let idString = "";
    // get the values of the keys
    const values = Object.values(data);
    console.log(values);
    if (values.length === 0) {
      return alert("Please select a row to delete");
    } else {
      values.forEach(async (value, i) => {
        // Create a string of IDs, separated by commas
        if (i === values.length - 1) {
          idString += value.ID;
        } else {
          idString += value.ID + ",";
        }
      });

      try {
        const url = `/deleteStockCount/${idString}`;
        const response = await fetch(url);

        if (response.status !== 200) {
          throw new Error(`Request failed with status ${response.status}`);
        }

        const result = await response.json();
        // Reload table
        try {
          const data = await LoadCountData(searchString, UserID);
          setDataSource(data.data);
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      } catch (error) {
        return console.error("Error:", error);
      }
    }
  };

  return (
    <>
      <div className="stock-container">
        <div className="container mt-4 d-flex justify-content-between">
          <div className="d-flex align-items-center">
            <Form.Label className="">Search: &nbsp;</Form.Label>
            <div className="text-input">
              <Form.Control
                size="sm"
                type="text"
                placeholder="Search..."
                value={searchString}
                onChange={(e) => {
                  setSearchString(e.target.value);
                }}
              />
            </div>
          </div>
          <div className="">
            {/* Apply count button */}
            <OverlayTrigger
              key="APPLYCOUNT"
              placement="bottom"
              overlay={<Tooltip id="tooltip-pdf">Apply Count</Tooltip>}
            >
              <Button
                variant="success"
                style={{
                  margin: "5px",
                  marginTop: "0px",
                  // border: "1px solid black",
                }}
                onClick={() => {
                  setShowConfirmModal(true);
                  // applyStockCount(dataSource, UserID);
                  // setDisabled(true);
                }}
                disabled={
                  // disable if all rows arent selected
                  selected === undefined || numRowsSelected !== numRows
                }
              >
                Apply Count
              </Button>
            </OverlayTrigger>
            {/* Delete count button */}
            <OverlayTrigger
              key="DELETECOUNT"
              placement="bottom"
              overlay={<Tooltip id="tooltip-pdf">Delete Selected</Tooltip>}
            >
              <Button
                variant="danger"
                style={{
                  margin: "5px",
                  marginTop: "0px",
                }}
                onClick={() => {
                  setShowConfirmDeleteModal(true);
                  //deleteStockCount(selected);
                }}
                disabled={disabled}
              >
                Delete Selected
              </Button>
            </OverlayTrigger>
            {/* Export to PDF (Count Grid) */}
            <OverlayTrigger
              key="PDFEXPORT"
              placement="bottom"
              overlay={<Tooltip id="tooltip-pdf">Table to PDF</Tooltip>}
            >
              <Button
                variant="secondary"
                style={{
                  margin: "5px",
                  marginTop: "0px",
                  border: "1px solid black",
                }}
                onClick={() => {
                  const gridData = gridRef_count;
                  exportPDF_count(gridData);
                }}
                disabled={dataSource.length === 0}
              >
                <ImFilePdf />
              </Button>
            </OverlayTrigger>
          </div>
        </div>

        <div className="grid-container">
          <div className="stock-grid">
            <ReactDataGrid
              idProperty="ID"
              columns={columns}
              dataSource={dataSource}
              style={gridStyle}
              theme={theme}
              enableSelection={true}
              selected={selected}
              checkboxColumn
              onSelectionChange={onSelectionChange}
              renderRowContextMenu={renderRowContextMenu}
              handle={setGridRef_count}
            />
          </div>
        </div>
      </div>

      {/* Confirm Apply Modal */}
      <Modal show={showConfirmModal} onHide={() => setShowConfirmModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Are you sure?</Modal.Title>
        </Modal.Header>
        <Modal.Body>You are about to apply stock counts.</Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowConfirmModal(false)}
          >
            Cancel
          </Button>
          <Button
            variant="success"
            onClick={() => {
              applyStockCount(dataSource, UserID);
              setDisabled(true);
              setShowSuccessModal(true);
              setShowConfirmModal(false);
            }}
          >
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>
      {/* Confirm Delete Modal */}
      <Modal
        show={showConfirmDeleteModal}
        onHide={() => setShowConfirmDeleteModal(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>Are you sure?</Modal.Title>
        </Modal.Header>
        <Modal.Body>You are about to delete stock counts.</Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowConfirmDeleteModal(false)}
          >
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={() => {
              deleteStockCount(selected);
              setDisabled(true);
              setShowSuccessModal(true);
              setShowConfirmDeleteModal(false);
            }}
          >
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>
      {/* Success Modal */}
      <Modal show={showSuccessModal} onHide={() => setShowSuccessModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Success</Modal.Title>
        </Modal.Header>
        <Modal.Body>Your action was successfull.</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => window.location.reload()}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Count;
